<mat-form-field class="business-chip-list" appearance="outline" subscriptSizing="dynamic">
  <mat-label>
    {{ multiple ? 'Select Multiple Businesses' : 'Select Business' }}
  </mat-label>
  <mat-chip-grid #chipList aria-label="Business selection">
    @if (multiple) { @for (business of selectedBusinesses; track business) {
    <mat-chip-row
      [selectable]="selectable"
      [removable]="removable"
      (removed)="removeBusiness(business)"
    >
      {{ business.name }}
      @if (removable) {
      <mat-icon matChipRemove>cancel</mat-icon>
      }
    </mat-chip-row>
    } } @else { @if (selectedBusinesses[0]) {
    <div class="mm-my-1">{{ selectedBusinesses[0].name }}</div>
    } } @if (multiple || !selectedBusinesses.length) {
    <input
      placeholder="Search for business..."
      #businessInput
      [formControl]="businessCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="addBusiness($event)"
    />
    }
  </mat-chip-grid>

  @if (!multiple && selectedBusinesses.length === 1 ) {
  <button
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="removeBusiness(selectedBusinesses[0])"
  >
    <mat-icon>close</mat-icon>
  </button>
  }

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (business of filteredBusinesses | async; track business) {
    <mat-option [value]="business">
      {{ business.name }}
    </mat-option>
    } @if (noResultsFound) {
    <mat-option>No results found </mat-option>
    }
  </mat-autocomplete>
  @if (businessLoading) {
  <mat-spinner matSuffix diameter="24"></mat-spinner>
  }
</mat-form-field>
